import InviteFriendReferralsPage from './InviteFriendReferralsPage'

export default InviteFriendReferralsPage
// eslint-disable-next-line import/export
export * from './InviteFriendReferralsPage'
